import { zergApi } from "@/service/zerg";

const prefix = "/rrhh/aumento-sueldo";

class AumentoSueldoService {


    async index(params) {
        try {
            const data = await zergApi.post(`${prefix}/index`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async store(params) {
        try {
            const data = await zergApi.post(`${prefix}/store`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async show(params) {
        try {
            const data = await zergApi.post(`${prefix}/show`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async update(params) {
        try {
            const data = await zergApi.post(`${prefix}/update`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }



    async destroy(params) {
        try {
            const data = await zergApi.post(`${prefix}/destroy`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }


    async updateStatus(params) {
        try {
            const data = await zergApi.post(`${prefix}/changeStatus`, params);
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getInfoSalarialEmpleadoById(employeeId) {
        try {
            const data = await zergApi.post(`${prefix}/info-salarial-employee/show`, { employee_id: employeeId });
            return data;
        } catch (error) {
            throw error;
        }
    }

    async getHistorialAumento(employeeId) {
        try {
            const data = await zergApi.post(`${prefix}/get-history`, { employee_id: employeeId })
            return data;
        } catch (error) {
            throw error;
        }
    }

    async exportToExcel(params) {
        try {
            const data = await zergApi.post(`${prefix}/excel`, params, {
                responseType: "blob",
            });
            return data;
        } catch (error) {
            throw error;
        }
    }

}

export default new AumentoSueldoService();